export const handleErrorDefineWallet = (
  error: any,
  onError: (message: string) => void,
): void => {
  console.error('Error while defining the wallet:', error);
  onError('Your information could not be set.');
};
